import { render, staticRenderFns } from "./WorkoutCreateNew.vue?vue&type=template&id=4efdca64&scoped=true&xmlns=true"
import script from "./WorkoutCreateNew.vue?vue&type=script&lang=js"
export * from "./WorkoutCreateNew.vue?vue&type=script&lang=js"
import style0 from "./WorkoutCreateNew.vue?vue&type=style&index=0&id=4efdca64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efdca64",
  null
  
)

export default component.exports